import { z } from "zod";
import type { ColumnDescriptor, DashRow } from "@/dash/v2/v2.types";
import { ColumnDescriptorSchema } from "@/dash/v2/schemas";

export const AutoTunePresentationSchema = z.object({
  columns: z.array(ColumnDescriptorSchema),
  // Same runtime check as the `z.record(z.unknown())` this replaces (object, not
  // array) — narrowing the values would throw on data the live status path accepts.
  row: z.custom<DashRow>(v => typeof v === "object" && v !== null && !Array.isArray(v)),
  column: z.string(),
});

export interface AutoTunePresentation {
  columns: ColumnDescriptor[];
  row: DashRow;
  column: string;
}
